"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var saveButtons = document.querySelectorAll('.common-save-button');

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = saveButtons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var saveBtn = _step.value;

            if (saveBtn.alreadyRegisteredClick === true) return;

            saveBtn.addEventListener('click', saveCommon);
            saveBtn.alreadyRegisteredClick = true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    function saveCommon(event) {
        var saveButton = event.target;
        var inputSelector = saveButton.dataset.commonSaveInputSelector || 'common-save-input';
        var savingObject = {};

        var saveUrl = saveButton.dataset.commonSaveUrl;
        var inputList = document.querySelectorAll(inputSelector);

        if (inputList.length === 0) {
            console.warn("No input items found by selector " + inputSelector);
            return;
        }
        if (!saveUrl) {
            console.warn("No URL defined for saving. Please define it by parameter: data-common-save-url (dataset.commonSaveUrl) of saving button.");
            return;
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = inputList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var input = _step2.value;

                // multiple options how to name parameter, which will be inserted into request body
                var paramName = input.dataset.commonSaveParamName || input.dataset.commonSaveParameterName || input.id || input.name;
                if (!paramName) continue;

                var valueProperty = input.dataset.commonSaveValueProperty;

                var value = valueProperty ? input[valueProperty] : input.value;
                // test only null or undefined, because 0 or '' is valid value
                if (value === null || value === undefined) {
                    // last try :)
                    value = input.textContent;
                }

                if (value.match(/^[0-9]+$/)) {
                    value = parseInt(value);
                } else if (value.match(/^[0-9]+[.,]?[0-9]*$/)) {
                    value = parseFloat(value.replace(',', '.'));
                }

                savingObject[paramName] = value;
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        var entityId = saveButton.dataset.commonSaveId;
        if (entityId) savingObject.Id = entityId;

        var ajaxHelper = new _ajaxHelper2.default();
        ajaxHelper.sendRequest(saveUrl, function (httpRequest, rspObj) {
            saveDone(httpRequest, rspObj, saveButton);
        }, savingObject);
    }

    function saveDone(httpRequest, responseObject, saveButton) {
        if (responseObject.success) {
            var message = responseObject.result.message;

            (0, _sweetalert2.default)({ text: message, title: message }, function () {
                var afterSaveUrl = saveButton.dataset.commonSaveAfterSaveUrl;

                if (afterSaveUrl) {
                    window.location.href = afterSaveUrl;
                }
            });
        } else {
            _notify2.default.error(responseObject.message);
            console.error(responseObject.detail);
        }
    }
};

var _ajaxHelper = require("../ajaxHelper");

var _ajaxHelper2 = _interopRequireDefault(_ajaxHelper);

var _sweetalert = require("sweetalert");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

var _notify = require("linksoft/notify");

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/Initializers/commonSaver.js
// module id = 403
// module chunks = 0